import { render, staticRenderFns } from "./CommonBenefits.vue?vue&type=template&id=0ada38d1"
import script from "./CommonBenefits.vue?vue&type=script&lang=js"
export * from "./CommonBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports